import {Event} from 'main.core';

export class Modal extends Event.EventEmitter {
    static instances = {};

    constructor(params = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Catalog.Modal');

        this.el = params.element;
        if (!this.el) {
            throw new Error('Необходимо передать элемент');
        }

        this.classes = {
            hidden: 'hidden',
        };
        this.attrs = {
            bg: 'data-modal-bg',
            closeButton: 'data-modal-close',
        };

        this.initControls();

        this.constructor.addInstance(this);

        this.buttonsCode = params.buttonsCode;
        this.initOpenButtons();
    }

    initOpenButtons() {
        if (!this.buttonsCode) {
            return;
        }

        document.querySelectorAll("[data-local-modal=\"" + this.buttonsCode + "\"]:not([data-local-modal-inited])")
            .forEach((button) => {
                button.addEventListener('click', this.onModalButtonClick.bind(this));
                button.setAttribute('data-local-modal-inited', '');
            });
    }

    initControls() {
        this.el.querySelectorAll('[' + this.attrs.closeButton + ']')
            .forEach((el) => el.addEventListener('click', this.onClose.bind(this), true));

        this.el.querySelectorAll('[' + this.attrs.bg + ']')
            .forEach((el) => el.addEventListener('click', this.onBackgroundClose.bind(this, el), true));

        if (this.el.hasAttribute(this.attrs.bg)) {
            this.el.addEventListener('click', this.onBackgroundClose.bind(this, this.el), true);
        }
    }

    getId() {
        return this.el.id;
    }

    isOpen() {
        return !this.el.classList.contains(this.classes.hidden);
    }

    open(options = {}) {
        if (!this.inDocument()) {
            this.insertIntoDocument();
        }
        this.addClass = options.addClass

        this.el.classList.add(options.addClass)

        this.el.classList

        this.el.classList.remove(this.classes.hidden);
        this.el.removeAttribute('aria-hidden');
        document.body.classList.add('overflow-hidden');

        this.emit('open', {
            sourceEvent: options.sourceEvent
        });
    }

    close() {
        this.el.classList.add(this.classes.hidden);
        this.el.setAttribute('aria-hidden', true);
        document.body.classList.remove('overflow-hidden');
        Event.EventEmitter
            .emit('BX.Asteq.Catalog.Modal:close');
        this.emit('close');
    }

    inDocument() {
        return !!this.el.parentElement;
    }

    insertIntoDocument() {
        if (this.inDocument()) {
            console.error('Модельное окно уже в документе');
            return;
        }
        document.body.insertAdjacentElement('beforeend', this.el);
    }

    removeFromDocument() {
        this.el.remove();
    }

    onClose(e) {
        this.close();
    }

    onBackgroundClose(bgElement, e) {
        if (e.target != bgElement) {
            return;
        }
        this.close();
    }

    onModalButtonClick(e) {
        this.open({
            sourceEvent: e,
        });
    }

    static getInstance(modalId) {
        const modal = this.instances[modalId];
        if (!modal) {
            return null;
        }

        return modal;
    }

    static addInstance(modal) {
        const modalId = modal.getId();
        if (this.instances[modalId]) {
            console.warn(`Модальное окно с таким id уже создано (${modalId}).`);
            return;
        }
        this.instances[modalId] = modal;
    }
}